import React, { useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import useSrlHelper from "../../hooks/useSrlHelper";
import CommonTable from "../tables/CommonTable";

const StackedItemsModal = ({ stackedItems, onHide }) => {
  // const [showModal, setShow] = useState(false);
  // const [stackedItems, setStackedItems] = useState([]);
  const showModal = stackedItems.length > 1;

  const { getAssetColumnsForNearByAssets } = useSrlHelper();
  const tableColumns = useMemo(() => {
    return getAssetColumnsForNearByAssets((show) => {
      if (!show) hideModal();
    });
  }, []);
  const hideModal = () => {
    // setShow(false);
    onHide && onHide();
  };
  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={() => hideModal()}
        size={"lg"}
        style={{ zIndex: "9999999 !important;" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Total count {stackedItems.length}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CommonTable data={stackedItems} columns={tableColumns} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant={"secondary"} onClick={() => hideModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default StackedItemsModal;
